import { render, staticRenderFns } from "./TopHeader.CollectionEdit.vue?vue&type=template&id=e4acdf52&"
import script from "CJ/components/topHeader.component.collectionEdit?vue&type=script&lang=js&"
export * from "CJ/components/topHeader.component.collectionEdit?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports